import React, { useEffect, useRef } from "react";
import { useCustomToast } from "../../../utils/toastUtils";

interface SuccessBannerProps {
  message: string;
  linkText?: string;
  onLinkClick?: () => void;
  onClose?: () => void;
}

const SuccessBanner: React.FC<SuccessBannerProps> = ({
  message,
  linkText,
  onLinkClick,
  onClose,
}) => {
  const { showToastWithProps } = useCustomToast();
  const hasShownToastRef = useRef(false); // Ref to track if toast has been shown

  useEffect(() => {
    if (!hasShownToastRef.current) {
      hasShownToastRef.current = true; // Mark as shown
      showToastWithProps({
        message,
        type: "success",
        duration: 10000,
        position: "top",
        actionText: linkText,
        onActionClick: onLinkClick,
        onClose,
      });
    }
  }, []);

  return null; // Render nothing since this component is for triggering toasts only
};

export default SuccessBanner;
